export const professionList = [
  {Id: '1', Name: 'Banking Professional'},
  {Id: '2', Name: 'Chartered Accountant'},
  {Id: '3', Name: 'Company Secretary'},
  {Id: '4', Name: 'Finance Professional'},
  {Id: '5', Name: 'Investment Professional'},
  {Id: '6', Name: 'Accounting Professional (Other)'},
  {Id: '7', Name: 'Admin Professional'},
  {Id: '8', Name: 'Human Resources Professional'},
  {Id: '9', Name: 'Advertising Professional'},
  {Id: '10', Name: 'Entertainment professional'},
  {Id: '11', Name: 'Event Manager'},
  {Id: '12', Name: 'Journalist'},
  {Id: '13', Name: 'Media Professional'},
  {Id: '14', Name: 'Public Relation Professional'},
  {Id: '15', Name: 'Farming'},
  {Id: '16', Name: 'Horticulturist'},
  {Id: '17', Name: 'Agricultural Professional (Other)'},
  {Id: '18', Name: 'Air Hostess/Flight Attendant'},
  {Id: '19', Name: 'Pilot/Co-Pilot'},
  {Id: '20', Name: 'Other Airline Professional'},
  {Id: '21', Name: 'Architect'},
  {Id: '22', Name: 'Interior Designer'},
  {Id: '23', Name: 'Landscape Architect'},
  {Id: '24', Name: 'Animator'},
  {Id: '25', Name: 'Commercial Artist'},
  {Id: '26', Name: 'Web/ox Designer'},
  {Id: '27', Name: 'Artist'},
  {Id: '28', Name: 'Other'},
  {Id: '29', Name: 'Beautician'},
  {Id: '30', Name: 'Fashion Designer'},
  {Id: '31', Name: 'Hair Stylist'},
  {Id: '32', Name: 'Jewelry Designer'},
  {Id: '33', Name: 'Designer (Other)'},
  {Id: '34', Name: 'Customer Support/BPO/KPO Professional'},
  {Id: '35', Name: 'IAS/IPS/IES/IFS'},
  {Id: '36', Name: 'Indian Police Services IPS'},
  {Id: '37', Name: 'Law Enforcement (Other)'},
  {Id: '38', Name: 'Air force'},
  {Id: '39', Name: 'Army'},
  {Id: '40', Name: 'Navy'},
  {Id: '41', Name: 'Defense Services (Other)'},
  {Id: '42', Name: 'Lecturer'},
  {Id: '43', Name: 'Professor'},
  {Id: '44', Name: 'Research Assistant'},
  {Id: '45', Name: 'Research Scholar'},
  {Id: '46', Name: 'Teacher'},
  {Id: '47', Name: 'Training Professional (Other)'},
  {Id: '48', Name: 'Civil Engineer'},
  {Id: '49', Name: 'Electronic/Telecom Engineer'},
  {Id: '50', Name: 'Mechanical/Production Engineer'},
  {Id: '51', Name: 'Non IT Engineer (Other)'},
  {Id: '52', Name: 'Chief/Sommelier/Food Critic'},
  {Id: '53', Name: 'Caterlng Professional'},
  {Id: '54', Name: 'Hotel/Hospitality Professional (Others)'},
  {Id: '55', Name: 'Software Developer/Programmer'},
  {Id: '56', Name: 'Software Consultant'},
  {Id: '57', Name: 'Hardware & Networking Professional'},
  {Id: '58', Name: 'Software Professional (Others)'},
  {Id: '59', Name: 'Lawyer'},
  {Id: '60', Name: 'Legal Assistant'},
  {Id: '61', Name: 'Legal Professional (Others)'},
  {Id: '62', Name: 'Dentist'},
  {Id: '63', Name: 'Doctor'},
  {Id: '64', Name: 'Medical Transcriptionist'},
  {Id: '65', Name: 'Nurse'},
  {Id: '66', Name: 'Pharmacist'},
  {Id: '67', Name: 'Physician Assistant'},
  {Id: '68', Name: 'Physiotherapist/Occupational Therapist'},
  {Id: '69', Name: 'Psychologist'},
  {Id: '70', Name: 'Surgeon'},
  {Id: '71', Name: 'Veterinary Doctor'},
  {Id: '72', Name: 'Therapist (Others)'},
  {Id: '73', Name: 'Medical/Healthcare Professional (Others)'},
  {Id: '74', Name: 'Merchant Naval Officer'},
  {Id: '75', Name: 'Mariner'},
  {Id: '76', Name: 'Marketing Professional'},
  {Id: '77', Name: 'Sales Professional'},
  {Id: '78', Name: 'Biologist/Botanist'},
  {Id: '79', Name: 'Physicist'},
  {Id: '80', Name: 'Science Professional (Others)'},
  {Id: '81', Name: 'Cxo/Chairman/Director/President'},
  {Id: '82', Name: 'VP/AVP/GM/DGM'},
  {Id: '83', Name: 'Sr. Manager/Manager'},
  {Id: '84', Name: 'Consultant/Supervisor/Team Leader'},
  {Id: '85', Name: 'Team Member/Staff'},
  {Id: '86', Name: 'Agent/Broker/Trader/Contractor'},
  {Id: '87', Name: 'Business Owner/Entrepreneur'},
  {Id: '88', Name: 'Politician'},
  {Id: '89', Name: 'Social Worker/Volunteer/NGO'},
  {Id: '90', Name: 'Sportsman'},
  {Id: '91', Name: 'Travel & Transport Professional'},
  {Id: '92', Name: 'Writer'},
  {Id: '93', Name: 'Postman'},
  {Id: '94', Name: 'No Profession'},
];
